import RevisionStatusIcon from 'components/RevisionStatusIcon';
import { SignatureRow } from 'components/tables/data/signature/types';

/**
 * Column for the signature status.
 */
export default function StatusColumn({ data: { revisionStatus } }: { data: SignatureRow }) {
  return <RevisionStatusIcon statusId={revisionStatus.revisionStatusId} />;
}
